<template>
  <div class="row">
    <div class="col-md-3 col-sm-3 col-lg-3 clor" @click="slotClick()">
      <SideNav />
    </div>

    <div class="col-md-9 col-sm-9 col-lg-9">
      <!-- <h1 id="hideId" class="text-center">Blog</h1> -->

      <slot />
    </div>
  </div>
</template>

<script>
import SideNav from "@/components/SideNav";
export default {
  components: {
    SideNav,
  },
  mounted() {
    this.nombreRuta = '/blog';
    console.log(this.nombreRuta);
    localStorage.setItem("blogName", this.nombreRuta);
  },
  methods: {
    slotClick() {
      document.getElementById("hideId").style.display = "none";
      console.log("dssd");
    },
  },
};
</script>
<style scoped>
.classContainer {
  font-size: 15px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.row {
  max-width: 100%;
}
.clor {
  background-color: #f5f5f5;
}
h1 {
  font-size: 35px;
}
</style>
